// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2976":"c3eea414","5593":"8e34dbd1"}[chunkId] + ".chunk.css";
};